import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_ACTIVIDADES_EXTRAS = 'ALL_ACTIVIDADES_EXTRAS';
export const LOADING_ALL_ACTIVIDADES_EXTRAS = 'LOADING_ALL_ACTIVIDADES_EXTRAS';
export const ACTIVO_ACTIVIDADES_EXTRAS = 'ACTIVO_ACTIVIDADES_EXTRAS';
export const PARAMS_ACTIVIDADES_EXTRAS = 'PARAMS_ACTIVIDADES_EXTRAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const actividadesExtrasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ACTIVIDADES_EXTRAS:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case LOADING_ALL_ACTIVIDADES_EXTRAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ACTIVIDADES_EXTRAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ACTIVIDADES_EXTRAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
